import createIcon from '../../createIcon';

/**
 * @component @name AddReaction
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgOS41VjcuNUgxNVYzLjM0QzEzLjc3IDIuOCAxMi40MiAyLjUgMTAuOTkgMi41QzUuNDcgMi41IDEgNi45OCAxIDEyLjVDMSAxOC4wMiA1LjQ3IDIyLjUgMTAuOTkgMjIuNUMxNi41MiAyMi41IDIxIDE4LjAyIDIxIDEyLjVDMjEgMTEuNDUgMjAuODMgMTAuNDUgMjAuNTMgOS41SDE3Wk0xNC41IDguNUMxNS4zMyA4LjUgMTYgOS4xNyAxNiAxMEMxNiAxMC44MyAxNS4zMyAxMS41IDE0LjUgMTEuNUMxMy42NyAxMS41IDEzIDEwLjgzIDEzIDEwQzEzIDkuMTcgMTMuNjcgOC41IDE0LjUgOC41Wk03LjUgOC41QzguMzMgOC41IDkgOS4xNyA5IDEwQzkgMTAuODMgOC4zMyAxMS41IDcuNSAxMS41QzYuNjcgMTEuNSA2IDEwLjgzIDYgMTBDNiA5LjE3IDYuNjcgOC41IDcuNSA4LjVaTTExIDE4QzguNjcgMTggNi42OSAxNi41NCA1Ljg5IDE0LjVIMTYuMTFDMTUuMzEgMTYuNTQgMTMuMzMgMTggMTEgMThaTTIxIDMuNUgyM1Y1LjVIMjFWNy41SDE5VjUuNUgxN1YzLjVIMTlWMS41SDIxVjMuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AddReaction = createIcon('AddReaction', [
  [
    'path',
    {
      d: 'M17 9.5V7.5H15V3.34C13.77 2.8 12.42 2.5 10.99 2.5C5.47 2.5 1 6.98 1 12.5C1 18.02 5.47 22.5 10.99 22.5C16.52 22.5 21 18.02 21 12.5C21 11.45 20.83 10.45 20.53 9.5H17ZM14.5 8.5C15.33 8.5 16 9.17 16 10C16 10.83 15.33 11.5 14.5 11.5C13.67 11.5 13 10.83 13 10C13 9.17 13.67 8.5 14.5 8.5ZM7.5 8.5C8.33 8.5 9 9.17 9 10C9 10.83 8.33 11.5 7.5 11.5C6.67 11.5 6 10.83 6 10C6 9.17 6.67 8.5 7.5 8.5ZM11 18C8.67 18 6.69 16.54 5.89 14.5H16.11C15.31 16.54 13.33 18 11 18ZM21 3.5H23V5.5H21V7.5H19V5.5H17V3.5H19V1.5H21V3.5Z',
      key: 'f0kbih',
    },
  ],
]);

export default AddReaction;
